import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {LoaderService} from '../modules/shared/components/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

    constructor(public loaderService: LoaderService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let blocking = true;

        if (req.params.get('doNotShowLoader')) {
            blocking = false;
        }

        if (blocking) {
            this.loaderService.show();
        }

        return next.handle(req)
            .pipe(
                map(event => {
                    if (event instanceof HttpResponse && blocking) {
                        this.loaderService.hide();
                    }
                    return event;
                }),
                catchError((error: any) => {
                    if (error instanceof HttpErrorResponse) {
                        if (blocking) {
                            this.loaderService.hide();
                        }
                    }
                    return throwError(error);
                })
            );
    }

}
